class ProductStakeOptions extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    this.#abortController = new AbortController();
    this.initValidation();
  }

  initValidation() {
    const { signal } = this.#abortController;
    /** @type {NodeListOf<HTMLInputElement>} */
    const allInputs = this.querySelectorAll('.product-stake-options__input');
    /** @type {NodeListOf<HTMLInputElement>} */
    const requiredInputs = this.querySelectorAll('input[required]');
    const formId = this.dataset.formId;

    allInputs.forEach((input) => {
      ['blur', 'change'].forEach((eventType) => {
        input.addEventListener(
          eventType,
          () => {
            input.value = input.value.toUpperCase();
          },
          { signal }
        );
      });

      input.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Enter') {
            input.value = input.value.toUpperCase();
          }
        },
        { signal }
      );
    });

    requiredInputs.forEach((input) => {
      const errorText = input.parentElement?.querySelector('.product-stake-options__error-text');

      // Prevent native browser HTML tooltip popup and show custom red text
      input.addEventListener(
        'invalid',
        (e) => {
          e.preventDefault();
          if (errorText instanceof HTMLElement) {
            errorText.style.display = 'block';
          }
        },
        { signal }
      );

      // Hide error text as soon as user enters text
      input.addEventListener(
        'input',
        () => {
          if (input.value.trim() !== '') {
            if (errorText instanceof HTMLElement) {
              errorText.style.display = 'none';
            }
          }
        },
        { signal }
      );
    });

    if (formId) {
      const form = document.getElementById(formId);
      if (form) {
        /** @param {SubmitEvent} e */
        const formSubmitHandler = (e) => {
          let hasError = false;
          allInputs.forEach((input) => {
            input.value = input.value.toUpperCase();
          });
          requiredInputs.forEach((input) => {
            const errorText = input.parentElement?.querySelector('.product-stake-options__error-text');
            if (!input.value || input.value.trim() === '') {
              hasError = true;
              if (errorText instanceof HTMLElement) {
                errorText.style.display = 'block';
              }
            }
          });
          if (hasError) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        };

        form.addEventListener('submit', formSubmitHandler, { capture: true, signal });
      }
    }
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }
}

if (!customElements.get('product-stake-options-component')) {
  customElements.define('product-stake-options-component', ProductStakeOptions);
}

export default ProductStakeOptions;
